<ng-container *ngIf="isActive">
  <div class="lg:hidden bg-gray-dark">
    <nav class="px-8 py-24">
      <ul class="flex flex-col gap-8">
        <ng-container *ngFor="let link of links">
          <li class="text-white h4">
            <ng-container *ngIf="link.external">
              <a href="{{ link.url }}" target="_blank"><span>{{ link.text }}</span></a>
            </ng-container>
            <ng-container *ngIf="!link.external">
              <a
                [routerLink]="link.url"
                href="#"
                routerLinkActive="text-red is-active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span>{{ link.text }}</span>
              </a>
            </ng-container>
          </li>
        </ng-container>
        <li class="pt-16 w-200">
          <app-register-button></app-register-button>
        </li>
      </ul>
    </nav>
  </div>
</ng-container>
